import { Address } from "@/@types/Address";
import { initialAddress } from "@/utils/constants";
import React, { useState } from "react";
import { FieldValues, UseFormRegister } from "react-hook-form";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Row,
} from "reactstrap";
import ShippingAddressForm from "./shipping-address-form";

type ShippingInformationProps = {
  shipFrom: Address;
  shipTo: Address;
  setShipTo: (value: React.SetStateAction<Address>) => void;
  shipDate: Date;
  setShipDate: (value: React.SetStateAction<Date>) => void;
  setShipFrom: (value: React.SetStateAction<Address>) => void;
};

const ShippingInformation = ({
  shipFrom,
  setShipFrom,
  shipTo,
  setShipTo,
  shipDate,
  setShipDate,
}: ShippingInformationProps) => {
  return (
    <Card className="rounded-0 border-0 shadow-lg mb-5">
      <CardHeader className="bg-white">
        <CardTitle className="fs-5" tag="h2">
          Shipping Information
        </CardTitle>
      </CardHeader>
      <CardBody>
        <Row>
          <Col xs={12} lg={6}>
            <ShippingAddressForm
              shipLabel="Ship From"
              address={shipFrom}
              setAddress={setShipFrom}
              shipDate={shipDate}
              setShipDate={setShipDate}
            />
          </Col>
          <Col xs={12} lg={6}>
            <ShippingAddressForm
              shipLabel="Ship To"
              address={shipTo}
              setAddress={setShipTo}
              isResidential
            />
          </Col>
        </Row>
        <Button
          className="float-start rounded-0 text-uppercase"
          outline
          color="danger"
          onClick={() => {
            setShipFrom(initialAddress);
            setShipDate(new Date());
          }}
        >
          Clear
        </Button>
        <Button
          className="float-end rounded-0 text-uppercase"
          outline
          color="danger"
          onClick={() => setShipTo(initialAddress)}
        >
          Clear
        </Button>
      </CardBody>
    </Card>
  );
};

export default ShippingInformation;
